import { useEffect, useMemo, useState } from 'react';
import { VISTA_CONSOLIDADO, mergeMonedas } from '../utils/currencyView';

export default function useStickyMonedas(items, vista) {
  const extracted = useMemo(
    () => mergeMonedas((items || []).flatMap((item) => item.monedas || [])),
    [items]
  );
  const [known, setKnown] = useState([]);

  useEffect(() => {
    setKnown((prev) => {
      if (vista === VISTA_CONSOLIDADO && extracted.length) return extracted;
      return mergeMonedas(prev, extracted);
    });
  }, [extracted, vista]);

  return known;
}
